<template>
  <div>
    <tabs />

    <v-container>

        <v-row>
            <v-col class="hdr">
                <h1>Sudden Death</h1>
            </v-col>
        </v-row>

        <v-row class="pt-3 pb-5 px-5">
            <v-col id="current-sd-container" cols="12">
                <sudden-death-widget></sudden-death-widget>
            </v-col>
        </v-row>

        <v-row v-if="currentSeasonSDGames">
            <v-col cols="12" md="6" v-for="game in currentSeasonSDGames" :key="game.id">
                <div class="pa-5">
                    <sudden-death-table :sdgame="game" :is-current-game="false"></sudden-death-table>
                </div>
            </v-col>
        </v-row>


    </v-container>
  </div>
</template>

<script>
  import Tabs from '@/components/Tabs.vue';
  import {mapGetters} from "vuex";
  import SuddenDeathTable from "../components/SuddenDeathTable";
  import SuddenDeathWidget from '@/components/SuddenDeathWidget';

  export default {
    name: "SuddenDeath",
    components: {
      SuddenDeathTable,
      SuddenDeathWidget,
      Tabs,
    },
    computed: {
      ...mapGetters([
        'currentSeasonSDGames',
      ]),
    },
    created() {
      if (!this.currentSeasonSDGames) {
        this.$store.dispatch('getCurrentSeasonSdGames');
      }
    },
  }
</script>

<style scoped>

    #current-sd-container {
        border: 3px solid var(--v-secondary-base);
        background-color: snow;
    }

</style>
